module.exports = __webpack_public_path__ + "static/media/icon-header-settings.b78b6dd2.svg";